module.exports = __webpack_public_path__ + "img/km.db8c9c93.svg";